<button
  type="button"
  *ngFor="let opt of options"
  [class.selected]="opt && opt.value === selectedValue"
  (click)="select(opt)"
>
  {{ opt.label | translate }}
</button>
